module.exports = __webpack_public_path__ + "static/media/bubble-pro.f7282b52.png";